import {FallcoClass} from '../../../classes/FallcoClass';
import FormHelper from '../../formHelper';
import * as Moment from "moment";

/**
 * @typedef {Object} RvObject
 *
 * @property {jQuery} $form
 * @property {jQuery} $submits
 * @property {Object} dom_observer
 * @property {Array} errors
 * @property {Boolean} initialized
 * @property {Array.<Object>} inputs_obj
 * @property {Object} options
 *
 * @method add_error
 * @method get_input_obj
 * @method get_submit
 * @method init
 * @method is_inizialized
 * @method load_inputs
 * @method show_alert_error
 * @method update_submit
 * @method validate
 */

/**
 * Libreria che permette di compilare i campi di un form passandogli i dati in un object
 * dove ogni chiave rappresenta il name di un campo del form.
 */
class FormFiller extends FallcoClass {
  
  constructor () {
    super('form_filler');
    
    /**
     * Selettori che vengono usati per recuperare i campi compilabili di un form
     *
     * @type {Array.<String>}
     */
    this.controls_selectors = [
      'input:not([type=\'button\'])',
      'input:not([type=\'submit\'])',
      'input:not([type=\'reset\'])',
      'select',
      'textarea'
    ];
    /**
     * Elenco di attributi da controllarne l'esistenza e nel qual caso triggerare l'evento "change".
     * Questo deve essere fatto per poter attivare eventuali altre librerie in ascolto sul singolo elemento,
     * come ad esempio Tipizzazione, Cleave, ControlBinding, ecc.
     *
     * @type {Array.<String|Object>}
     */
    this.trigger_change_attributes = [
      'fw-input-type',
      'fw-control-bind-selector'
    ];
    
    return super.expose_to_public('form_filler', this);
  }
  
  /**
   * Compila i campi di un form in base ai dati contenuti nel parametro "data"
   *
   * @param {JQuery | HTMLElement} form
   * @param {Object} data
   * @param {Boolean} [trigger_form_changed] - default: false
   * @param {Boolean} [trigger_input_change=false] - default: false
   */
  fill (form, data, trigger_form_changed, trigger_input_change=false ) {
    /**
     * @type {NodeList}
     */
    let controls;
    
    /**
     * Oggetto recuperato dal data("rv_object") del form stesso nel caso in cui
     * sul form ci sia il required_validate attivo.
     * @type {RvObject}
     */
    let required_validate_object;
    
    /**
     * Controlliamo se l'object form è di tipo jquery, nel qual caso lo si converte in HTMLElement
     */
    if (form instanceof jQuery) {
      required_validate_object = form.data('rv_object');
      
      form = form[0];
    } else {
      required_validate_object = $(form).data('rv_object');
    }
    
    /**
     * Se il form non esiste per qualche motivo, ferma la libreria.
     */
    if (!form) {
      fallco.console.warn('Il form passato non è un elemento valido.');
      
      return;
    }

    this._showLoadingFrame();

    controls = form.querySelectorAll(this.controls_selectors.join(','));
    
    controls.forEach((control, i) => {
      let control_name = control.name;
      
      /**
       * Se tra i dati da compilare non esiste la chiave con il name del campo,
       * non fa nulla e passa all'elemento successivo.
       */
      if (data[control_name] === undefined) {
        return;
      }
      
      this._setInputValue(control, data[control_name], i, trigger_form_changed, trigger_input_change);
    });
    
    if (required_validate_object) {
      required_validate_object.validate();
    }
    
    if (!trigger_form_changed && trigger_input_change) {
      // form.dispatchEvent(new Event("change"));
      // $(form).trigger("change");
      FormHelper.reset_form_changes(form);
    }

    this._hideLoadingFrame();

    super.trigger_custom_event({
      name:   'complete',
      target: form,
      data:   {
        controls_updated: controls
      }
    });
  }
  
  /**
   * Resetta i campi del form
   *
   * @param {JQuery | HTMLElement} form
   */
  
  reset (form) {
    /**
     * @type {NodeList}
     */
    let controls;
    
    /**
     * Oggetto recuperato dal data("rv_object") del form stesso nel caso in cui
     * sul form ci sia il required_validate attivo.
     * @type {RvObject}
     */
    let required_validate_object;
    
    /**
     * Controlliamo se l'object form è di tipo jquery, nel qual caso lo si converte in HTMLElement
     */
    if (form instanceof jQuery) {
      required_validate_object = form.data('rv_object');
      
      form = form[0];
    } else {
      required_validate_object = $(form).data('rv_object');
    }
    
    /**
     * Se il form non esiste per qualche motivo, ferma la libreria.
     */
    if (!form) {
      fallco.console.warn('Il form passato non è un elemento valido.');
      
      return;
    }

    this._showLoadingFrame();

    controls = form.querySelectorAll(this.controls_selectors.join(','));
    
    controls.forEach((control, i) => {
      if ((typeof control.realDefaultValue != 'undefined')
        && control.name) {
        
        if (Array.isArray(control.realDefaultValue)
          && control.realDefaultValue.length === 0) {
          return;
        }
        
        this._setInputValue(control, control.realDefaultValue, i);
      }
    });
    
    if (required_validate_object) {
      required_validate_object.validate();
    }

    this._hideLoadingFrame();

    super.trigger_custom_event({
      name:   'reset',
      target: form,
      data:   {
        controls_updated: controls
      }
    });
  }
  
  /**
   * @deprecated
   */
  update_form_data(){
    this.updateFormData()
  }
  
  updateFormData(){
  
  }
  
  /**
   * Imposta il value del campo specificato, triggerando eventualmente l'evento change
   *
   * @param {HTMLElement} control
   * @param {String | Number} value
   * @param {Number} i
   * @param {Boolean} [trigger_form_changed]
   * @param {Boolean} [trigger_input_change=false]
   * @private
   */
  _setInputValue (control, value, i, trigger_form_changed, trigger_input_change = false) {
    let control_type           = control.localName.toLowerCase();
    const control_tipizzazione = control.getAttribute('fw-input-type');
    let has_attributes         = false;
  
    if (value === null || value === undefined) {
      value = '';
    }

    /**
     * Se l'input ha fw-input-type="valuta", nel caso in cui il back-end ritorni un valore intero (double)
     * invece di un decimal, forziamo il valore che riempie il campo ad essere un float
     */
    if (control_tipizzazione === 'valuta' && value !== '') {
      value = parseFloat(value).toFixed(2);
    }

    /**
     * Se l'input ha fw-input-type="data" oppure fw-input-type="data-ora"
     * se il valore non è vuoto e non è in formato italiano (non contiene '/') è un timestamp
     * quindi setto il value convertito in formato italiano
     */
    if (control_tipizzazione === 'data' && value !== '' && !/\//.test(value)) {
      value = Moment(value).format('DD/MM/YYYY')
    } else if (control_tipizzazione === 'data-ora' && value !== '' && !/\//.test(value)) {
      value = Moment(value).format('DD/MM/YYYY HH:mm')
    }
  
    /**
     * In caso di input, fa una distinzione tra RADIO e CHECKBOX in modo
     * da poter settare correttamente il valore anche di questi campi.
     */
    if (control_type === 'input') {
      let type_attr = control.getAttribute('type').toLowerCase();
    
      if (type_attr === 'radio' || type_attr === 'checkbox') {
        control_type = type_attr;
      }
    }
  
    switch (control_type) {
      case 'select':
        let values           = [];
        let option_to_select = control.querySelectorAll('option');
      
      if (value instanceof Array) {
        values = value.toString();
      } else {
        values.push(value.toString());
      }
      
      control.realDefaultValue = control.realDefaultValue || [];
      option_to_select.forEach((option) => {
        option.selected = values.indexOf(option.value) > -1;
        
        if (!trigger_form_changed) {
          option.realDefaultSelected = option.realDefaultSelected || option.defaultSelected;
          option.defaultSelected     = values.indexOf(option.value) > -1;
          if (option.realDefaultSelected) {
            control.realDefaultValue.push(option.value);
          }
        }
      });
      
      if (control.classList.contains('selectpicker')) {
        $(control).selectpicker('refresh');
      }
      break;
    case 'radio':
    case 'checkbox':
      if (control_type === 'checkbox' && typeof value === 'boolean' && value) {
        control.checked = true;
      } else if (control.value && control.value.toString() === value.toString()) {
        control.checked = true;

        if (!trigger_form_changed) {
          control.realDefaultValue = control.realDefaultValue || control.defaultValue;
          control.defaultChecked = true;
        }
        if (trigger_input_change) {
          control.dispatchEvent(new CustomEvent('click', { bubbles: true }));
        }
      }
      break;
    default:
      if (typeof value === 'number' || !Number.isNaN(+value)) {
        control.value = value.toString().replace('.', ',');
      } else {
        // input testuale | textarea
        control.value = value ? value.toString() : '';
      }
      
      if (!trigger_form_changed) {
        control.realDefaultValue = control.realDefaultValue || control.defaultValue;
        control.defaultValue     = value ? value.toString() : '';
      }
    }
    
    this.trigger_change_attributes.map((attr) => {
      if (control.hasAttribute(attr)) {
        has_attributes = true;
      }
    });
    
    if (control.fv) {
      control.dispatchEvent(new CustomEvent('input', { bubbles: true }));
    }
    
    if (has_attributes || trigger_form_changed || trigger_input_change) {
      control.dispatchEvent(new CustomEvent('change', { bubbles: trigger_form_changed || trigger_input_change || false }));
    }
  }

  _showLoadingFrame() {
    if ($.helper && $.helper.loading_frame) {
      $.helper.loading_frame.show(parent);
    }
  }

  _hideLoadingFrame() {
    if ($.helper && $.helper.loading_frame) {
      $.helper.loading_frame.hide();
    }
  }

}

export default new FormFiller();
